import ActionTypes from "../constants/ActionTypes";

const initialState = {
  loading: false,
  users: [],
  error: null,
  alldatanumber: 0,
  is_null: false
};
const userListReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_USERS_REQUEST:
      return { ...state, loading: true };
    case ActionTypes.FETCH_USERS_SUCCESS:
      return { ...state, loading: false, users: action.payload.data_list, alldatanumber: action.payload.all_data_count, is_null: action.payload.data_list.length === 0};
    case ActionTypes.FETCH_USERS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default userListReducer;
